export default function CashBackIcon(props) {
    const { style, ...rest } = props

    return (
        <svg
            width='20'
            height='20'
            viewBox='0 0 20 20'
            xmlns='http://www.w3.org/2000/svg'
            style={style}
            {...rest}
            fill='none'
        >
            <g clip-path='url(#clip0_163_21137)'>
                <path
                    d='M10 15.8334H5C4.33696 15.8334 3.70107 15.57 3.23223 15.1011C2.76339 14.6323 2.5 13.9964 2.5 13.3334V6.66669C2.5 6.00365 2.76339 5.36776 3.23223 4.89892C3.70107 4.43008 4.33696 4.16669 5 4.16669H15C15.663 4.16669 16.2989 4.43008 16.7678 4.89892C17.2366 5.36776 17.5 6.00365 17.5 6.66669V10.4167'
                    stroke='currentColor'
                    stroke-opacity='0.88'
                    stroke-width='1.6'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                />
                <path
                    d='M2.5 8.33331H17.5'
                    stroke='currentColor'
                    stroke-opacity='0.88'
                    stroke-width='1.6'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                />
                <path
                    d='M5.83333 12.5H5.84167'
                    stroke='currentColor'
                    stroke-opacity='0.88'
                    stroke-width='1.6'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                />
                <path
                    d='M9.16667 12.5H10.8333'
                    stroke='currentColor'
                    stroke-opacity='0.88'
                    stroke-width='1.6'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                />
                <path
                    d='M13.3333 15.8333H18.3333'
                    stroke='currentColor'
                    stroke-opacity='0.88'
                    stroke-width='1.6'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                />
                <path
                    d='M15.8333 13.3333L13.3333 15.8333L15.8333 18.3333'
                    stroke='currentColor'
                    stroke-opacity='0.88'
                    stroke-width='1.6'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                />
            </g>
            <defs>
                <clipPath id='clip0_163_21137'>
                    <rect width='20' height='20' fill='white' />
                </clipPath>
            </defs>
        </svg>
    )
}
